import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/listen-aura-web-logo.webp";
import "./Footer.css";

export const Footer = () => {
  return (
    <div className="footerContainer">
      <div className="container footerFlex">
        <div className="footerLogo">
          <img src={logo} alt="Logo" />
        </div>

        <div className="termsList">
          <span>
            <Link to="/terms-and-conditions">
              Terms & Conditions for Empathetic Listeners
            </Link>
          </span>
          <span>
            <Link to="/terms-and-conditions-service">
              Terms & Conditions of Services
            </Link>
          </span>
          <span>
            <Link to="/privacy-policy">Privacy Policy</Link>
          </span>
        </div>
        <div className="termsList">
          <span>
            <Link to="/refund-and-cancellation-policy">
              Refund & Cancellation Policy{" "}
            </Link>
          </span>
          <span>
            <Link to="/shipping-and-delivery-policy">
              Shipping & Delivery Policy{" "}
            </Link>
          </span>
        </div>

        <div className="copyText">
          <span>Copyright 2026 - Listenaura</span>
        </div>
      </div>
    </div>
  );
};
